(function () {
  if (window.__dbEmailMemberOfferInitialized) return;
  window.__dbEmailMemberOfferInitialized = true;

  var formId = 'URhMNi';
  var teaserId = 'db-email-offer-teaser';
  var dismissedKey = 'dbEmailOfferDismissed';
  var autoOpenedKey = 'dbEmailOfferAutoOpened';
  var productAutoOpenDelay = 3000;
  var browsingAutoOpenDelay = 3000;
  var couponPattern = /\b(?:DBW10|DB10)-[A-Z0-9]+\b/i;
  var couponObserver = null;

  function hideTeaser(remember) {
    var teaser = document.getElementById(teaserId);
    if (teaser) teaser.hidden = true;
    if (remember) sessionStorage.setItem(dismissedKey, '1');
  }

  function showTeaser() {
    if (localStorage.getItem('dbEmailOfferClaimed') === '1') return;
    if (sessionStorage.getItem(dismissedKey) === '1') return;
    var teaser = document.getElementById(teaserId);
    if (teaser) teaser.hidden = false;
  }

  function isCommerceEntryPage() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    return path === '/' || path.indexOf('/products/') === 0 || path.indexOf('/collections/') === 0;
  }

  function addTeaser() {
    if (document.getElementById(teaserId) || sessionStorage.getItem(dismissedKey) === '1') return;

    var style = document.createElement('style');
    style.id = 'db-email-offer-teaser-style';
    style.textContent = [
      '.db-email-offer-teaser{position:fixed;right:0;bottom:0;width:120px;height:120px;z-index:2147483000;display:block;font-family:inherit;pointer-events:none;}',
      '.db-email-offer-teaser[hidden]{display:none!important;}',
      '.db-email-offer-teaser__open{position:absolute;right:0;bottom:0;width:120px;height:120px;min-width:0;padding:0;border:0;border-radius:0;background:#5fa6d0;color:transparent;box-shadow:none;clip-path:polygon(100% 0,100% 100%,0 100%);cursor:pointer;pointer-events:auto;overflow:hidden;}',
      '.db-email-offer-teaser__open::after{content:"GET £10 OFF";position:absolute;right:-21px;bottom:41px;width:138px;color:#fff;font:800 14px/1 Arial,sans-serif;letter-spacing:.02em;text-align:center;text-transform:uppercase;transform:rotate(-45deg);transform-origin:center;}',
      '.db-email-offer-teaser__dismiss{position:absolute;left:4px;bottom:4px;width:22px;height:22px;padding:0;border:1px solid #fff;border-radius:50%;background:#000;color:#fff;box-shadow:none;font:400 16px/1 Arial,sans-serif;cursor:pointer;pointer-events:auto;}',
      '.db-email-offer-teaser button:focus-visible{outline:2px solid #111;outline-offset:2px;}',
      '@media(min-width:750px){.db-email-offer-teaser{width:134px;height:134px;}.db-email-offer-teaser__open{width:134px;height:134px;}.db-email-offer-teaser__open::after{right:-21px;bottom:48px;width:152px;font-size:15px;}.db-email-offer-teaser__dismiss{left:6px;bottom:6px;}}'
    ].join('');
    document.head.appendChild(style);

    var teaser = document.createElement('div');
    teaser.id = teaserId;
    teaser.className = 'db-email-offer-teaser';
    teaser.innerHTML = '<button class="db-email-offer-teaser__open" type="button" data-db-email-offer-open aria-haspopup="dialog">GET &pound;10 OFF</button><button class="db-email-offer-teaser__dismiss" type="button" data-db-email-offer-dismiss aria-label="Dismiss offer">&times;</button>';
    document.body.appendChild(teaser);
  }

  function openKlaviyoOffer() {
    // Manual opens also consume this visit's automatic popup.
    sessionStorage.setItem(autoOpenedKey, '1');
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    hideTeaser(false);
  }

  function updateSuccessCopy() {
    var nodes = document.querySelectorAll('p, span, div');
    for (var index = 0; index < nodes.length; index += 1) {
      var node = nodes[index];
      if (node.children.length === 0 && node.textContent.trim() === 'Tap it below to apply automatically at checkout.') {
        node.textContent = 'Applied automatically to your cart. Keep the code as a backup.';
        break;
      }
    }
  }

  function applyUniqueCoupon(code) {
    var normalized = code.toUpperCase();
    if (sessionStorage.getItem('dbAppliedCoupon') === normalized) return;

    var redirect = window.location.pathname + window.location.search;
    var url = '/discount/' + encodeURIComponent(normalized) + '?redirect=' + encodeURIComponent(redirect);
    fetch(url, { credentials: 'same-origin', redirect: 'follow' })
      .then(function (response) {
        if (!response.ok) throw new Error('Discount application failed');
        sessionStorage.setItem('dbAppliedCoupon', normalized);
        document.documentElement.setAttribute('data-db-subscriber-discount', 'applied');
        updateSuccessCopy();
      })
      .catch(function () {
        document.documentElement.setAttribute('data-db-subscriber-discount', 'copy-code');
      });
  }

  function findAndApplyCoupon() {
    var match = document.body.innerText.match(couponPattern);
    if (!match) return false;
    applyUniqueCoupon(match[0]);
    return true;
  }

  function watchForCoupon() {
    if (findAndApplyCoupon()) return;
    if (couponObserver) couponObserver.disconnect();

    couponObserver = new MutationObserver(function () {
      if (!findAndApplyCoupon()) return;
      couponObserver.disconnect();
      couponObserver = null;
    });
    couponObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () {
      if (couponObserver) couponObserver.disconnect();
      couponObserver = null;
    }, 15000);
  }

  document.addEventListener('click', function (event) {
    var dismiss = event.target.closest('[data-db-email-offer-dismiss]');
    if (dismiss) {
      event.preventDefault();
      hideTeaser(true);
      return;
    }

    var trigger = event.target.closest('[data-db-email-offer-open]');
    if (!trigger) return;

    event.preventDefault();
    openKlaviyoOffer();
  });

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    if (detail.formId !== formId) return;

    if (detail.type === 'open' || detail.type === 'close' || detail.type === 'submit') {
      sessionStorage.setItem(autoOpenedKey, '1');
    }

    if (detail.type === 'open') {
      hideTeaser(false);
      return;
    }

    if (detail.type === 'submit') {
      localStorage.setItem('dbEmailOfferClaimed', '1');
      hideTeaser(true);
      watchForCoupon();
      return;
    }

    if (detail.type === 'close') showTeaser();
  });

  function scheduleAutoOpen() {
    if (!isCommerceEntryPage()) return;
    if (sessionStorage.getItem(autoOpenedKey) === '1') return;

    window.setTimeout(function () {
      if (localStorage.getItem('dbEmailOfferClaimed') === '1') return;
      if (sessionStorage.getItem(dismissedKey) === '1') return;
      if (sessionStorage.getItem(autoOpenedKey) === '1') return;

      sessionStorage.setItem(autoOpenedKey, '1');
      openKlaviyoOffer();
    }, window.location.pathname.indexOf('/products/') === 0
      ? productAutoOpenDelay
      : browsingAutoOpenDelay);
  }

  function boot() {
    if (localStorage.getItem('dbEmailOfferClaimed') === '1') return;
    if (!isCommerceEntryPage()) return;
    addTeaser();
    scheduleAutoOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
